import { render, staticRenderFns } from "./CommunityHealthInfo.vue?vue&type=template&id=0c7c5be6&scoped=true&"
import script from "./CommunityHealthInfo.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c5be6",
  null
  
)

export default component.exports